// Shared public-site settings context.
// Extracted into its own module to break a circular import between
// PublicLayout -> FloatingActions -> ChatWidget -> PublicLayout.
import { createContext } from "react";

export const SettingsContext = createContext(null);
